import { useQuery } from "@tanstack/react-query";
import { projectDetailsApi } from "..";

export const useCostTrend = (projectId: string | undefined) => {

    const month = [
        { month: "Jan" },
        { month: "Feb" },
        { month: "Mar" },
        { month: "Apr" },
        { month: "May" },
        { month: "Jun" },
        { month: "Jul" },
        { month: "Aug" },
        { month: "Sep" },
        { month: "Oct" },
        { month: "Nov" },
        { month: "Dec" },
    ];

    const { data, isFetching, isPending, isError } = useQuery({
        queryKey: ["project-cost-trend", projectId],
        queryFn: () => projectDetailsApi.fetchProjectCostTrend(projectId)
    });

    return {
        costTrendData: data?.data?.actual_monthly.map((item: any, index: number) => ({
            month: month[index]?.month || "",
            actual: item.value,
            forecast: data.data.forecast_monthly[index]?.value,
        })) || [],
        isPending, isFetching, isError
    }

};